<app-header-menu #headerMenu (clickScroll)="onClick($event)"></app-header-menu>
<ng-container *transloco="let t">
  <app-splash-screen *ngIf="showSplash" [@fadeInOut]></app-splash-screen>
  <div id="onboarding-desktop">
    <div class="header">
      <mat-icon [matMenuTriggerFor]="headerMenu.menu" class="menu"
        >menu</mat-icon
      >
      <div class="app-logo" title="{{t('epson-logo-alt')}}"></div>
      <div class="nav-left" *ngIf="showContainer">
        <a id="a-benefits" (click)="onClick('benefits')"
          >{{ t('onboarding-benefits') }}</a
        >
        <a id="a-rewards" (click)="onClick('rewards')"
          >{{ t('onboarding-rewards') }}</a
        >
        <a id="a-categories" (click)="onClick('categories')"
          >{{ t('onboarding-categories') }}</a
        >
        <a id="a-faq" (click)="onClick('faq')">{{ t('onboarding-faq') }}</a>
        <a href="{{this.termsAndConditionsLink}}" target="_blank" rel="noopener"
          >{{t('onboarding-about')}}</a
        >
      </div>
      <div class="nav-right">
        <a id="a-createaccount" [routerLink]="'/'+RouterKeys.REGISTER"
          >{{ t('onboarding-createaccount') }}</a
        >
        <button
          id="button-login"
          [routerLink]="'/'+RouterKeys.LOGIN"
          mat-button-desktop
        >
          {{ t('goto-login') }}
        </button>
      </div>
    </div>
    <app-welcome-onboarding></app-welcome-onboarding>
    <div class="sections">
      <div class="section">
        <h1 title title id="benefits">{{ t('onboarding-benefits') }}</h1>
        <owl-carousel-o [options]="customOptions">
          <ng-template carouselSlide>
            <div class="grid-item">
              <mat-icon>groups</mat-icon>
              <app-paragraph>{{ t('onboarding-step-1') }}</app-paragraph>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="grid-item">
              <mat-icon>discount</mat-icon>
              <div>
                <app-paragraph
                  >{{ t('onboarding-step-2') }}
                  <a
                    class="read-tc"
                    href="{{this.termsAndConditionsLink}}"
                    target="_blank"
                    rel="noopener"
                    >{{t('register-terms-condition')}}</a
                  >
                  {{ t('onboarding-step-3') }}</app-paragraph
                >
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="grid-item">
              <div class="circle-area">
                <mat-icon>stars</mat-icon>
              </div>
              <app-paragraph>{{ t('onboarding-step-4') }}</app-paragraph>
            </div>
          </ng-template>
        </owl-carousel-o>
        <div class="buttons">
          <button mat-stroked-button id="landing-know-more"
          (click)="onClick('faq')">
            {{ t('landing-benefits-knowmore') }}
          </button>
          <button
            mat-button
            id="landing-start-now"
            [routerLink]="'/'+RouterKeys.REGISTER"
          >
            {{ t('landing-benefits-startnow') }}
          </button>
        </div>
      </div>
      <div class="section">
        <h1 title id="rewards">{{ t('onboarding-rewards') }}</h1>
        <h2>{{ t('onboarding-step-5') }}</h2>
        <owl-carousel-o [options]="customOptions">
          <ng-template carouselSlide>
            <div class="goal-card">
              <img
                src="../../../assets/images/rewards1.png"
                alt="{{ t('ink-detail-alt') }}"
                class="rewards-img"
              />
              <div class="card-footer">
                <hr />
                <div class="item-title">{{ t('landing-rewards-title-1') }}</div>
                <div class="item-description">
                  {{ t('landing-rewards-desc-1') }}
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="goal-card">
              <img
                src="../../../assets/images/rewards2.png"
                alt="{{ t('ink-detail-alt') }}"
                class="rewards-img"
              />
              <div class="card-footer">
                <hr />
                <div class="item-title">{{ t('landing-rewards-title-2') }}</div>
                <div class="item-description">
                  {{ t('landing-rewards-desc-2') }}
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="goal-card">
              <img
                src="../../../assets/images/rewards3.png"
                alt="{{ t('ink-detail-alt') }}"
                class="rewards-img"
              />
              <div class="card-footer">
                <hr />
                <div class="item-title">{{ t('landing-rewards-title-3') }}</div>
                <div class="item-description">
                  {{ t('landing-rewards-desc-3') }}
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="goal-card">
              <img
                src="../../../assets/images/rewards4.png"
                alt="{{ t('ink-detail-alt') }}"
                class="rewards-img"
              />
              <div class="card-footer">
                <hr />
                <div class="item-title">{{ t('landing-rewards-title-4') }}</div>
                <div class="item-description">
                  {{ t('landing-rewards-desc-4') }}
                </div>
              </div>
            </div>
          </ng-template>
        </owl-carousel-o>
        <div class="rewards-bottom-desc">{{ t('landing-rewards-desc-4') }}</div>
      </div>
      <div class="section">
        <h1 title id="categories">{{ t('onboarding-categories') }}</h1>
        <owl-carousel-o [options]="customOptions">
          <ng-template carouselSlide>
            <div class="goal-card category-card">
              <img
                src="../../../assets/images/categories1.png"
                alt="{{ t('ink-detail-alt') }}"
              />
              <div class="card-footer">
                <div class="item-description">
                  {{ t('landing-categories-title-f') }}
                </div>
                <div class="item-description-categories">
                  {{ t('landing-categories-description-f') }}
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="goal-card category-card">
              <img
                src="../../../assets/images/categories2.png"
                alt="{{ t('ink-detail-alt') }}"
              />
              <div class="card-footer">
                <div class="item-description">
                  {{ t('landing-categories-title-s') }}
                </div>
                <div class="item-description-categories">
                  {{ t('landing-categories-description-s') }}
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="goal-card category-card">
              <img
                src="../../../assets/images/categories3.png"
                alt="{{ t('ink-detail-alt') }}"
              />
              <div class="card-footer">
                <div class="item-description">
                  {{ t('landing-categories-title-f-vip') }}
                </div>
                <div class="item-description-categories">
                  {{ t('landing-categories-description-f-vip') }}
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="goal-card category-card">
              <img
                src="../../../assets/images/categories4.png"
                alt="{{ t('ink-detail-alt') }}"
              />
              <div class="card-footer">
                <div class="item-description">
                  {{ t('landing-categories-title-s-vip') }}
                </div>
                <div class="item-description-categories">
                  {{ t('landing-categories-description-s-vip') }}
                </div>
              </div>
            </div>
          </ng-template>
        </owl-carousel-o>
      </div>
    </div>
    <div class="faq">
      <div class="grid-faq">
        <div class="faq-img" title="{{ t('people-working-alt') }}"></div>
        <div class="faq-container">
          <h1 title id="faq">{{ t('landing-faq-title') }}</h1>
          <div class="faq-content">
            <div class="question">
              <h2 title>{{ t('landing-faq-q1') }}</h2>
              <p>{{ t('landing-faq-a1') }}</p>
              <hr />
            </div>
            <div class="question">
              <h2 title>{{ t('landing-faq-q2') }}</h2>
              <p>
                {{ t('landing-faq-a2') }}
                <strong>{{ t('landing-faq-a2-models') }}</strong>
              </p>
              <hr class="third-question" />
            </div>
            <div class="question third-question">
              <h2 title>{{ t('landing-faq-q3') }}</h2>
            <ul>
              <li>
                <p>
                  {{ t('landing-faq-a3-1') }}
                  <a
                    href="{{t('landing-faq-a3-1-link')}}"
                    target="_blank"
                    rel="noopener"
                    >{{t('landing-faq-a3-1-link').slice(8)}}</a
                  >{{ t('landing-faq-a3-1-2') }}
                </p>
              </li>
              <li>
                <p>{{ t('landing-faq-a3-2') }}</p>
              </li>
              <li>
                <p>{{ t('landing-faq-a3-3') }}</p>
                <ul>
                  <li>
                    <p>{{ t('landing-faq-a3-4') }}</p>
                  </li>
                  <li>
                    <p>{{ t('landing-faq-a3-5') }}</p>
                  </li>
                </ul>
              </li>
            </ul>
              <p>{{ t('landing-faq-a3-6') }}</p>
            </div>
            <div class="more-questions-button">
              <button mat-stroked-button
              [routerLink]="'/'+RouterKeys.FAQ">
                {{ t('landing-faq-more-questions') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-join-onboarding></app-join-onboarding>
    <app-footer-onboarding 
        [termsAndConditionsLink]="termsAndConditionsLink"
        [privacyPolicyLink]="privacyPolicyLink">
    </app-footer-onboarding>
  </div>
</ng-container>
